import type { SyntheticEvent } from 'react';
import type { PoiType, XY } from 'src/lib/player/store';
import { onlyMouseEvents } from 'src/lib/player/utils';
import { onClickGenerator } from 'src/lib/player/utils/onClickGenerator';
import type { Bounds } from '../InfoSheet/SVGChart';
import { PoiIconSVG } from '../Sidebar/PoiListItem';
import {
  getInterpolatedElevation,
  getInterpolatedY,
  isDataXInView,
  projectX,
  type ViewRange,
} from './heightChartUtils';

export function HeightChartPoi({
  poi,
  bounds,
  viewRange,
  filteredTrack,
  isSelected,
  onClick,
  onHover,
  onHoverOut,
}: {
  poi: PoiType;
  bounds: Bounds;
  viewRange: ViewRange;
  filteredTrack: Array<XY>;
  isSelected: boolean;
  onClick: (event: SyntheticEvent) => void;
  onHover: (event: SyntheticEvent) => void;
  onHoverOut: (event: SyntheticEvent) => void;
}) {
  const { offset } = poi;
  if (offset == null || Number.isNaN(offset)) return null;
  if (!isDataXInView(offset, viewRange)) return null;
  const { minY, maxY } = viewRange;
  const poiX = projectX(offset, viewRange, bounds);
  const elevation = getInterpolatedElevation(filteredTrack, offset);
  const lowerY = isSelected ? getInterpolatedY(elevation, minY, maxY, bounds) : 0;

  return (
    <>
      {isSelected && (
        <line x1={poiX} x2={poiX} y1={2} y2={lowerY} stroke={poi.markerColor.hex} strokeWidth={2} />
      )}
      <g
        transform={`translate(${poiX - 10} 0) scale(0.5 0.5)`}
        {...onClickGenerator(onClick)}
        onPointerEnter={onlyMouseEvents(onHover)}
        onPointerLeave={onlyMouseEvents(onHoverOut)}
      >
        <PoiIconSVG poi={poi} />
      </g>
    </>
  );
}
